// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawerRight_SideDrawer__3xpym","Open":"SideDrawerRight_Open__Fo+yD","Close":"SideDrawerRight_Close__E9c9e","Logo":"SideDrawerRight_Logo__pDoJB"};